module.exports = __webpack_public_path__ + "img/20190722162150706.8be0f4ca.png";